import styled from 'styled-components'
import { Button } from '@material-ui/core'

export const Wrapper = styled.div`
  display: grid;
  width: 100%;
  height: 100vh;
  justify-content: center;
  align-items: center;
`
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
`
export const Header = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
`
export const Body = styled.div`
  margin-top: 1rem;
  max-width: 768px;
`
export const Footer = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: flex-end;
`

export const ButtonContainer = styled.div`
  padding: 0.5rem;
`
export const SubmitButton = styled(Button)`
  color: white;
  background-color: red;
  min-width: 8rem;

  &:hover {
    background-color: grey;
  }
`

export const CancelButton = styled(Button)`
  color: white;
  background-color: black;
  min-width: 8rem;

  &:hover {
    background-color: grey;
  }
`

export const SaveButton = styled(Button)`
  color: white;
  background-color: red;
  min-width: 8rem;

  &:hover {
    background-color: grey;
  }
`
